<main class="maintenance">
  <div class="maintenance__content">
    <img
      class="maintenance__logo"
      src="assets/nolia/logo/logo-horizontal.png"
      alt="Nolia"
      width="148"
      height="34"
    />

    <!-- §06: la jerarquía es siempre la misma pila de tres -->
    <p class="nolia-eyebrow">
      {{ "maintenance-page.eyebrow" | translate }}
    </p>

    <h1 class="maintenance__title">
      {{ "maintenance-page.title" | translate }}
    </h1>

    <p class="maintenance__text">
      {{ "maintenance-page.sub-title" | translate }}
    </p>
    <p class="maintenance__text">
      {{ "maintenance-page.description" | translate }}
    </p>
  </div>

  <!-- §07: la única animación en loop autorizada es el logo — el personaje
       respira. Respeta prefers-reduced-motion. -->
  <img
    class="maintenance__character"
    src="assets/nolia/character/character.png"
    alt=""
    width="200"
    height="280"
    aria-hidden="true"
  />
</main>
